import Big from "big.js";
import { PreviewInvoiceType } from "../enums/PreviewInvoiceType";
import { SubscriptionStatus } from "../../../../../../enums/SubscriptionStatus";

export const getPreviewInvoiceType = (
    subtotalBefore, subtotalAfter, isBillingCycleChanged, subscriptionStatus,
) => {
    switch (subscriptionStatus) {
        case SubscriptionStatus.trial:
            return PreviewInvoiceType.SUBSCRIBE_DURING_TRIAL;
        case SubscriptionStatus.active_trial:
            return PreviewInvoiceType.SWITCH_DURING_ACTIVE_TRIAL;
        case SubscriptionStatus.trial_ended:
        case SubscriptionStatus.ended:
            return PreviewInvoiceType.SUBSCRIBE_AFTER_TRIAL;
        case SubscriptionStatus.active:
        default:
        {
            const subtotalAfterB = Big(subtotalAfter || 0);
            const subtotalBeforeB = Big(subtotalBefore || 0);

            if (isBillingCycleChanged) {
                // if from GROWTH/PREMIUM switch to any free plans (LAUNCH/ZERO), should show delay text
                if (subtotalAfterB.eq(0))
                    return PreviewInvoiceType.SWITCH_DIFF_BILLING_CYCLE_TO_FREE_PLAN;
                return PreviewInvoiceType.SWITCH_DIFF_BILLING_CYCLE;
            }

            // if (subtotalBeforeB.eq(0) && subtotalAfterB.gt(0))
            //     return PreviewInvoiceType.SWITCH_FREE_TO_PAID;
            if (subtotalAfterB.gt(subtotalBeforeB))
                return PreviewInvoiceType.SWITCH_SAME_CYCLE_UPGRADE;
            if (subtotalAfterB.eq(subtotalBeforeB))
                return PreviewInvoiceType.SWITCH_SAME_CYCLE_SAME;
            if (subtotalAfterB.lt(subtotalBeforeB))
                return PreviewInvoiceType.SWITCH_SAME_CYCLE_DOWNGRADE;

            throw new Error('getPreviewInvoiceType: unknown preview type');
        }
    }
};
